import * as React from "react";
import { IScenarioState } from "./Scenario";
import { TokenUtil, GameToken } from "./Card";
import { MessageBus } from "./Assert";
import { OtherComponentSelectorComponent } from "./OtherComponentSelector";
import { DeckUtil } from "./DeckUtil";

export interface IPhaseCounterProps {
    state: IScenarioState;
    onChanged: () => void;
}
class PhaseAction {
    prefix: string;
    title: string;
    action: () => void;
    constructor(prefix: string, title: string, action?: () => void) {
        this.prefix = prefix;
        this.title = title;
        this.action = action;
    }
}
export class PhaseCounterComponent extends React.Component<IPhaseCounterProps, any> {
    constructor(props: IPhaseCounterProps) {
        super(props);
        this.actions = [
            [
                new PhaseAction("1.1", "Round begins. Mythos phase begins."),
                new PhaseAction("1.2", "Place 1 doom on the current agenda.", () => {
                    const card = this.props.state.agendaState.deck.cards[0];
                    const doomTokens = TokenUtil.getToken(card, GameToken.Doom);
                    doomTokens.number++;
                    this.props.onChanged();
                }),
                new PhaseAction("1.3", "Check doom threshold."),
                new PhaseAction("1.4", "Each investigator draws 1 encounter card.", () => {
                    MessageBus.trigger(OtherComponentSelectorComponent.messageZoomEncounterCard);
                }),
                new PhaseAction("~", "PLAYER WINDOW"),
                new PhaseAction("1.5", "Mythos phase ends.", () => {this.setPhase(1);})
            ],
            [
                new PhaseAction("2.1", "Investigation phase begins."),
                new PhaseAction("~", "PLAYER WINDOW"),
                new PhaseAction("2.2", "Next investigator's turn begins."),
                new PhaseAction("~", "PLAYER WINDOW"),
                new PhaseAction("2.2.1", "Active investigator may take an action. If, return to previous player window. If not, proceed to 2.2.2."),
                new PhaseAction("2.2.2", "Investigator's turn ends. If an investigator has not yet taken a turn this phase, return to 2.2, else go to 2.3"),
                new PhaseAction("2.3", "Investigation phase ends.", () => { this.setPhase(2); })
            ],
            [
                new PhaseAction("3.1", "Enemy phase begins."),
                new PhaseAction("3.2", "Hunter enemies move."),
                new PhaseAction("~", "PLAYER WINDOW"),
                new PhaseAction("3.3", "Next investigator resolves engaged enemy attacks. If an investigator has not yet resolved enemy attacks this phase, return to previous player window. After final investigator resolves engaged enemy attacks, proceed to next player window."),
                new PhaseAction("~", " PLAYER WINDOW"),
                new PhaseAction("3.4", "Enemy phase ends.", () => { this.setPhase(3); })
            ],
            [
                new PhaseAction("4.4", "Upkeep phase begins"),
                new PhaseAction("~", "PLAYER WINDOW"),
                new PhaseAction("4.2", "Reset actions.", () => {
                    const ss = this.props.state;
                    //investigator
                    ss.investigators.forEach(i => {
                        //investigator portrait
                        i.portrait.exhausted = false;
                        //action tokens
                        const actionToken = TokenUtil.getToken(i.card, GameToken.Action);
                        actionToken.number = 3;
                        actionToken.canBeMoved = true;
                        actionToken.x = 5;
                        actionToken.y = 40;
                    });

                    this.props.onChanged();
                }),
                new PhaseAction("4.3", "Ready each exhausted card.", () => {
                    const ss = this.props.state;
                    //investigator
                    ss.investigators.forEach(i => {
                        //threat
                        DeckUtil.readyExhaustedCards(i.threat);
                        //inplay
                        DeckUtil.readyExhaustedCards(i.inPlay);
                    });
                    //location
                    ss.locations.forEach(loc => {
                        //enemies
                        DeckUtil.readyExhaustedCards(loc.enemies);
                    });
                    this.props.onChanged();
                }),
                new PhaseAction("4.4", "Each investigator draws 1 card and gains 1 resource", () => {
                    const ss = this.props.state;
                    //investigator
                    ss.investigators.forEach(i => {
                        //draw 1 card
                        const topCard = DeckUtil.removeTopCard(i.deck);
                        topCard.faceUp = true;
                        if (!topCard) {
                            alert("Investigator " + i.card.name + " has no more cards in deck.");
                        } else {
                            DeckUtil.addToTop(i.hand, topCard);
                        }
                        //gain 1 resource
                        const resources = TokenUtil.getToken(i.card, GameToken.Resource);
                        resources.number++;

                    });
                    this.props.onChanged();
                }),
                new PhaseAction("4.5", "Each investigator checks hand size.", () => {
                    const ss = this.props.state;
                    //investigator
                    ss.investigators.forEach(i => {
                        if (i.hand.cards.length > 8) {
                            alert("Investigator " + i.card.name + " has more than 8 cards in hand. You must discard " + (i.hand.cards.length - 8) + " cards.");
                        }
                    });
                }),
                new PhaseAction("4.5", "Upkeep phase ends. Round ends.", () => { this.setPhase(0); })
            ]
        ];
    }
    actions: PhaseAction[][];
    render() {
        let round = 1;
        let phase = 1;
        if (this.props.state.roundCounter) {
            round = this.props.state.roundCounter.round;
            phase = this.props.state.roundCounter.phase;
        }
        const actionsLi = this.actions[phase].map((a, i) => (<li key={i}>{a.prefix} {a.action ? <a onClick={() => { a.action() }}>{a.title}</a> : a.title}</li>));
        return (
            <div id="phase-counter">
                <div className="round">{round}</div>
                <ul className="phases">
                    <li onClick={() => this.setPhase(0)} className={phase === 0 ? "active" : ""}>Mythos</li>
                    <li onClick={() => this.setPhase(1)} className={phase === 1 ? "active" : ""}>Investigation</li>
                    <li onClick={() => this.setPhase(2)} className={phase === 2 ? "active" : ""}>Enemy</li>
                    <li onClick={() => this.setPhase(3)} className={phase === 3 ? "active" : ""}>Upkeep</li>
                </ul>
                <div className="phase-actions">
                    <ul>
                        {actionsLi}
                    </ul>
                </div>
            </div>
        );
    }

    setPhase(phase: number) {
        const counter = this.props.state.roundCounter || { round: 1, phase: 1 };
        if (phase === counter.phase) {
            return;
        }
        if (phase === 0 && counter.phase === 3) {
            counter.round++;
        } else if (phase === 3 && counter.phase === 0) {
            counter.round--;
        }
        counter.phase = phase;
        this.props.state.roundCounter = counter;
        this.props.onChanged();
    }
}
